/**
 * Parses an environment variable as a number.
 * Returns undefined if the environment variable is not set or is not a number.
 */
export function parseEnvNumber(env: string | undefined): number | undefined {
  const num = Number(env);
  return Number.isNaN(num) ? undefined : num;
}

/**
 * Parses an environment variable as a boolean.
 * Returns false if the environment variable is not set.
 */
export function parseEnvBoolean(env: string | undefined): boolean {
  return env === 'true';
}

/**
 * Normalizes the environment name.
 *
 * @param env - The environment name to normalize.
 * @returns The normalized environment name.
 */
export function normalizeEnvName(env: string | undefined): string {
  return env?.toLowerCase() === 'production' ? 'prod' : env ?? 'unknown';
}
